export const DND_BASE_LAYER_Z_INDEX = 16;
